import { withAuthGate } from '@sunrise-ui/composites';
import {
  isNative,
  useAuthStore,
  useSafeLocalSearchParams,
} from '@sunrise-ui/primitives';
import ProfileView from '@templates/ProfileView';
import { useRouter } from 'expo-router';
import React from 'react';

function UserProfileScreen() {
  const { userId } = useSafeLocalSearchParams<{ userId: string }>();
  const { currentUserId } = useAuthStore();
  const router = useRouter();

  // Redirect to /profile if viewing own profile
  React.useEffect(() => {
    if (userId && currentUserId && userId === currentUserId) {
      router.replace('/profile');
    }

    if (!userId) {
      router.replace('/');
    }
  }, [userId, currentUserId, router]);

  return <ProfileView userId={userId} />;
}

export default withAuthGate(UserProfileScreen, { requireAuth: isNative });
